







































import validaterules from './validate';
import { Component,Vue,Prop } from 'vue-property-decorator'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

@Component({
    components:{
        Treeselect
    }
})
export default class AddUser extends Vue{
    dialogImageUrl = '' //预览的图片地址
    dialogVisible = false
    @Prop({
        type: Object,
        default: {}
    })
    value:any
    @Prop({
        type: Array,
        default: []
    })
    options:any
    @Prop({
        type:String,
        default:'100px'
    })
    labelWidth:any
    get headers(){ // 
        const token = window.localStorage.getItem('token');
        return {Authorization:`Bearer ${token}`}
    }
    get uploadUrl(){
        return process.env.VUE_APP_API + '/common/uploadFile'
    }
    getRules({ ruleType, label, rules, prop }:any){
        if(rules) return rules;
        const result = [];
        const res = validaterules[ruleType];            
        for(let i in res){
            result.push({
                ...res[i],
                message: label + res[i].message
            })
        }            
        return result;
    }
    handleRemove(file:any, fileList:any) {
        console.log(file, fileList);
    }
    // 图片上传之后的预览
    handlePictureCardPreview(file:any) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
    }
    // 图片上传成功
    imageUploadSuccess(response:any, file:any, fileList:any) {
        console.log(fileList);
        console.log(response);
        
        this.value['images'] =  fileList.map( (item:any) => {
            if(!item.response){
                return item.url
            }else{
                return item.response.data.url
            }
        });
        
        
    }
    // 修改的时候进来展示图片的组装
    previewImg(e:any){
        const array:Array<any> = [];
        e.map((item:any) => {
            array.push({
                url: item
            })
        })
        return array
    }
    // 检查表单必填项目是否已经填写完毕
    submitForm():any{
        return new Promise((resovle,reject)=>{
            this.$refs['ruleForm'].validate((valid:any) => {
                    resovle(valid);
            });
        })
    }
    // 配置树形图的参数
    normalizer(node:any) {
        let data = {}
        this.options.forEach((item:any) => {
            if( item.type== 'tree'){
                data = {
                    id: node[item.treeId],
                    label: node[item.treeLabel],
                    children: node.children,
                }
            }
            
        });
        return data
        
    }
    // 重置表单
    resetForm() {
        console.log(111);
        this.$refs['ruleForm'].resetFields();
    }
}
